export default __webpack_public_path__ + "static/media/RAPDER.a7116dd9.png";